import { No, Yes } from '@/assets/icons/scorecard';
import { StrongNoIcon, StrongYesIcon } from './scorecardRatingIcons';

import { cloneDeep } from 'lodash-es';
const ratingOptionsConfig = [
  {
    value: 'strong_yes',
    label: 'Strong yes',
    icon: StrongYesIcon,
    isSelected: false,
    selectedColor: 'success-300',
    bgColor: 'pastel-2-light',
  },
  {
    value: 'yes',
    label: 'Yes',
    icon: Yes,
    isSelected: false,
    selectedColor: 'success-300',
    bgColor: 'pastel-2-light',
  },
  {
    value: 'no',
    label: 'No',
    icon: No,
    isSelected: false,
    selectedColor: 'error-300',
    bgColor: 'pastel-1-light',
  },
  {
    value: 'strong_no',
    label: 'Strong no',
    icon: StrongNoIcon,
    isSelected: false,
    selectedColor: 'error-300',
    bgColor: 'pastel-1-light',
  },
];

const ratingOptions = cloneDeep(ratingOptionsConfig);

const scorecardColors = {
  strong_yes: '#079455',
  yes: '#079455',
  no: '#B50808',
  strong_no: '#B50808',
};

const getSelectionRatingStyle = (selectedRating) => {
  let scorecardStyles = {};
  if (selectedRating?.value) {
    scorecardStyles = {
      color: scorecardColors?.[selectedRating?.value] || '#6D659D',
      className: `checked_${selectedRating?.value}`,
    };
  }
  return scorecardStyles;
};
export {
  ratingOptions,
  scorecardColors,
  getSelectionRatingStyle,
  ratingOptionsConfig,
};
